var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnsortedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "#FFFFFF",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 18,
    id: "icon-bound",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.24499 9.18582L11.111 5.39582C11.2877 5.14748 11.5737 5 11.8785 5C12.1833 5 12.4693 5.14748 12.646 5.39582L15.779 9.18582C16.0355 9.50645 16.0955 9.94198 15.9351 10.32C15.7747 10.698 15.4198 10.9575 15.011 10.9958H9.01099C8.60251 10.9569 8.24826 10.6971 8.08834 10.3192C7.92841 9.94132 7.98856 9.50617 8.24499 9.18582Z",
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.779 14.8058L12.911 18.5958C12.7343 18.8446 12.4481 18.9923 12.143 18.9923C11.8379 18.9923 11.5517 18.8446 11.375 18.5958L8.24499 14.8058C7.98856 14.4855 7.92841 14.0503 8.08834 13.6724C8.24826 13.2945 8.60251 13.0348 9.01099 12.9958H15.011C15.4198 13.0341 15.7747 13.2936 15.9351 13.6716C16.0955 14.0497 16.0355 14.4852 15.779 14.8058Z",
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnsortedIcon);
export default __webpack_public_path__ + "static/media/unsorted-icon.5bb2f151f0a2859c1e6bcd15021cda55.svg";
export { ForwardRef as ReactComponent };